import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Causas from "@/pages/Causas";

export const Route = createFileRoute("/causas/")({
  head: () => seoHead({
    title: "Causas e Instituições | Shopping do Bem",
    description: "Escolha a causa que você quer apoiar. Sua compra gera doações para instituições verificadas.",
    path: "/causas",
  }),
  component: Causas,
});
